import { Offer } from '../../types';

export const buildToggleEnabledPayload = (offer: Offer) => {
  const { id, version, scope, ...offerAttrs } = offer;

  return {
    ...offerAttrs,
    enabled: { ...offerAttrs.enabled, enabled: !offer.enabled.enabled },
  };
};
